<section class="flex h-full w-full flex-col overflow-hidden bg-white text-slate-900" role="dialog">
  <header class="flex shrink-0 items-center gap-3 border-b !border-slate-100 px-4 py-3">
    <div class="grid h-10 w-10 shrink-0 place-items-center rounded-lg bg-orange-50 text-orange-600">
      <app-icon>add_task</app-icon>
    </div>
    <h2 class="min-w-0 flex-1 truncate !m-0 !text-base !font-bold !leading-6">
      {{ 'crm_tasks.form.title_new' | translate }}
    </h2>
    <button
      type="button"
      class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-slate-500 hover:bg-slate-100"
      [attr.aria-label]="'close' | translate"
      (click)="requestClose()"
    >
      <app-icon>close</app-icon>
    </button>
  </header>

  @if (loading) {
    <div class="flex flex-1 flex-col gap-4 px-4 py-4">
      <div class="h-10 animate-pulse rounded-lg bg-slate-100"></div>
      <div class="h-24 animate-pulse rounded-lg bg-slate-100"></div>
      <div class="h-10 animate-pulse rounded-lg bg-slate-100"></div>
      <div class="h-10 animate-pulse rounded-lg bg-slate-100"></div>
    </div>
  } @else if (loadFailed) {
    <div class="flex flex-1 flex-col items-center justify-center gap-3 p-5 text-center">
      <app-icon class="!text-[32px] text-slate-300">error_outline</app-icon>
      <p class="!m-0 text-sm text-slate-600">{{ 'crm_tasks.form.load_failed' | translate }}</p>
      <app-button btnType="stroked" (onChangeClick)="load()">{{ 'crm_tasks.form.retry' | translate }}</app-button>
    </div>
  } @else {
    <div class="crm-scroll flex min-h-0 flex-1 flex-col gap-4 overflow-y-auto px-4 py-4">
      <app-task-fields [form]="form" [users]="users" [canLink]="canLink" />

      <div class="flex flex-col gap-2">
        <span class="text-xs">{{ 'crm_tasks.fields.reminders' | translate }}</span>
        <app-task-reminders
          [reminders]="reminders"
          [hasDeadline]="hasDeadline"
          (add)="addReminder($event)"
          (remove)="removeReminder($event)"
        />
      </div>
    </div>

    <footer class="flex shrink-0 gap-2 border-t !border-slate-100 px-4 py-3">
      <app-button
        btnType="stroked"
        class="flex-1"
        [customClass]="'w-full !h-10 !rounded-lg'"
        (onChangeClick)="requestClose()"
      >
        {{ 'cancel' | translate }}
      </app-button>
      <app-button
        class="flex-1"
        [customClass]="'w-full !h-10 !rounded-lg'"
        [disabled]="saving"
        (onChangeClick)="submit()"
      >
        {{ (saving ? 'saving' : 'create') | translate }}
      </app-button>
    </footer>
  }
</section>
